import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '@/components/ui/accordion'
import { Skeleton } from '@/components/ui/skeleton'

export const AppDeployLogsFallback = () => {
  return (
    <Accordion
      type="single"
      collapsible
      className="w-full border rounded-lg shadow-sm overflow-hidden"
      value="item-1"
      onValueChange={() => {}}
    >
      <AccordionItem
        value="item-1"
        className='[&_div[data-slot="accordion-content"]]:bg-background'
      >
        <AccordionTrigger className="bg-background px-4 rounded-none">
          <div className="w-full flex items-center gap-2">
            <Skeleton className="size-4 rounded-full" />
            <Skeleton className="h-4 w-30" />
            <Skeleton className="ml-auto h-4 w-10" />
          </div>
        </AccordionTrigger>
        <AccordionContent className="pb-0 -mx-[1px] w-[calc(100%_+_2px)] overflow-hidden bg-background rounded-t-lg border border-b-0 h-[calc(100vh-350px)] min-h-[300px]">
          <Skeleton className="h-full min-w-full" />
        </AccordionContent>
      </AccordionItem>
      <AccordionItem
        value="item-2"
        className='[&_div[data-slot="accordion-content"]]:bg-background'
      >
        <AccordionTrigger className="bg-background px-4 rounded-none">
          <div className="w-full flex items-center gap-2">
            <Skeleton className="size-4 rounded-full" />
            <Skeleton className="h-4 w-26" />
          </div>
        </AccordionTrigger>
      </AccordionItem>
    </Accordion>
  )
}
